import { SimplePage } from "@/app/_/marketing/SimplePage";
import { AgentOrchestration } from "@/app/_/sections/5AgentsSection/AgentOrchestration";
import AGENT_SCENARIO from "@/app/_/sections/5AgentsSection/agent-scenario";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Agentic accounting"
      title="Agents that actually close the books."
      subtitle="Ask for a report, a reconciliation, or an invoice draft — and watch agents coordinate across threads and workflows to get it done. Every action is logged, explainable, and reversible."
      secondaryCta={{
        label: "Meet the agents",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "thread-conversation",
        alt: "An agent drafting a new contact and its email for confirmation",
      }}
      capabilities={[
        {
          title: "Ask in plain English.",
          description:
            "Add a supplier, fill in an email, fix a record. The agent drafts each change where you can see it, and nothing is saved until you confirm.",
          imageName: "crop-thread-answer",
        },
        {
          title: "Teach it once. It holds.",
          description:
            "Turn a correction into a rule — matching, categorizing, splitting — that runs on every transaction that follows.",
          imageName: "crop-rules-table",
        },
        {
          title: "Every proposal comes with its reason.",
          description:
            "Matches and categories arrive as proposals that say why they were chosen. Approve, adjust, or reject — nothing posts on its own.",
          imageName: "crop-triage-suggestion",
        },
      ]}
      illustration={{
        title: "You ask. It reasons out loud.",
        description:
          "An orchestrator hands work to specialised agents — ingestion, intercompany detection, reconciliation, consolidation — and every step is logged.",
        render: () => <AgentOrchestration scenario={AGENT_SCENARIO} />,
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/triage", "/platform/multi-entity"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
